import { render, staticRenderFns } from "./IdentificationDocumentTypes.vue?vue&type=template&id=877b2052&"
import script from "./IdentificationDocumentTypes.vue?vue&type=script&lang=js&"
export * from "./IdentificationDocumentTypes.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationDocumentTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports